import { useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { history, useSession, useAPI, useMobileAPI } from 'global'
import Screen, { State } from './screen'

export default function Login(props) {
  const { t } = useTranslation(null, { useSuspense: false })
  const { teamKey } = props
  const api = useAPI()
  const mobile = useMobileAPI()
  const session = useSession()
  const screen = useRef()
  const [otpToken, setOTPToken] = useState(null)
  const [state, setState] = useState(mobile?.isAndroid ? State.loading : State.login)
  const listenerID = 'LoginComponent'

  useEffect(() => {
    let delayTimer = null
    // Render the login page in 200 ms if this a 'regular' Android login
    const loadingTimer = setTimeout(() => {
      if (state == State.loading && !delayTimer) setState(State.login)
    }, 200)

    mobile?.listen(listenerID, (event, payload) => {
      if (event == 'externalAuthenticationTokenProvided') {
        // If the auth token has been received, then start a timer to show the delayed loading UI after 1000 ms
        // e.g. if the API request is taking a while
        delayTimer = setTimeout(() => setState(State.delayedLoading), 500)
        api.exchangeExternalAuthCode(payload.accessToken, payload.teamKey).then(response => {
          if (delayTimer) clearTimeout(delayTimer)
          session.setAuthentication(response?.authentications?.[0])
          history.replace('/stores')
        }).catch(()=>{
          if (delayTimer) clearTimeout(delayTimer)
          setState(State.login)
          toast.error(t('error.invalidOAuthLogin'))
        })
      }
    })
    mobile?.post('checkForExternalAuthenticationToken')

    return () => {
      mobile?.unlisten(listenerID)
      if (delayTimer) clearTimeout(delayTimer)
      if (loadingTimer) clearTimeout(loadingTimer)
    }
  }, [])

  const submitLogin = (username, password) => {
    // TODO: change to loading status / show spinner
    api.login(username, password).then(response => {
      session.setAuthentication(response?.authentications?.[0])
      history.replace('/stores')
    }).catch(response => {
      if (response?.status === 401) {
        setOTPToken(response.error?.error?.validationErrors?.authentication?.token)
        return
      }

      let msg = `${t('error.login')}: ${response?.status}`
      if (response?.status >= 400 && response?.status < 500) msg = t('error.invalidCredentials')
      if (response?.status === 422) msg = t('error.lockedOut')
      toast.error(msg)
      screen.current.clear()
    }).catch(()=>{})
  }

  const submitOtp = otp => {
    api.otpRequest(otp, otpToken).then(response => {
      session.setAuthentication(response?.authentications?.[0])
      history.replace('/organizations')
    }).catch(()=>{})
  }

  return <Screen ref={screen} onSubmitLogin={submitLogin} onSubmitOtp={submitOtp} showOtp={otpToken} teamKey={teamKey} state={state} />
}
